import { render, staticRenderFns } from "./PackagingTypesCreateAdmin.vue?vue&type=template&id=18c09eb7&scoped=true"
import script from "./PackagingTypesCreateAdmin.vue?vue&type=script&lang=js"
export * from "./PackagingTypesCreateAdmin.vue?vue&type=script&lang=js"
import style0 from "./PackagingTypesCreateAdmin.vue?vue&type=style&index=0&id=18c09eb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c09eb7",
  null
  
)

export default component.exports